import React from "react";
import PetersAgricultureLanding from "../components/landing/LandingPage";

const HomePage: React.FC = () => {
  return <PetersAgricultureLanding />;
};

export default HomePage;
